import { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { apiHost } from "../api/apiClient";

const SESSION_VISIT_ID_KEY = "assettrakPageVisitSessionId";

function getSessionVisitId() {
  let sessionVisitId = window.sessionStorage.getItem(SESSION_VISIT_ID_KEY);

  if (!sessionVisitId) {
    sessionVisitId = `${Date.now()}-${Math.random().toString(36).substr(2, 10)}`;
    window.sessionStorage.setItem(SESSION_VISIT_ID_KEY, sessionVisitId);
  }

  return sessionVisitId;
}

const exactPageTitles = {
  "/": "Dashboard",
  "/home": "Dashboard",
  "/realTime": "RealTime",
  "/customers": "Customers",
  "/assets": "Assets",
  "/groups": "Groups",
  "/devices": "Devices",
  "/depots": "Depots",
  "/zones": "POI Zones",
  "/users": "Users",
  "/events": "Events",
  "/notifications": "Notifications",
  "/ibutton": "IButtons",
  "/visioncam": "Visioncam",
  "/help-centre": "Help Centre",
  "/help-centre/admin": "Manage Help Centre",
  "/tom-delivery": "TOM Delivery",
  "/manageAccount": "Manage Account",
  "/non-tracked-assets": "Non-tracked Assets",
  "/page-visits": "Page Visits",
  "/page-visits-heat-map": "Page Visits - Heat Map",
  "/raw-message-diagnostics": "Raw Message Diagnostics",
  "/Rpt-MVTL": "MV Trip Log",
  "/Rpt-Visit": "Visit Report",
  "/Rpt-Visit-New": "Visit Report",
  "/Rpt-Group-Summary": "Group Summary Report",
  "/Rpt-summary": "Asset Summary Report",
  "/Rpt-LocationData": "Location Data Report",
  "/Rpt-PointOfInterest": "POI Zone Visits (Multiple) Report",
  "/Rpt-Geofence": "POI Zone Entry/Exit Report",
  "/Rpt-IButton": "IButton Report",
  "/video-retrievals": "Retrieved recordings",
  "/Rpt-VideoUsage": "Customer Video Usage Report",
  "/Temperature": "Temperature Report",
  "/Track": "Track Report",
  "/Replay": "Replay Report",
  "/Timeline": "Timeline Report",
  "/asset-log-report": "Asset Log Report",
};

const prefixPageTitles = [
  { prefix: "/page-visits/user/", title: "Page Visits - User Detail" },
  { prefix: "/customers/create", title: "Create Customer" },
  { prefix: "/customers/edit", title: "Edit Customer" },
  { prefix: "/customers/delete", title: "Customer Details" },
  { prefix: "/assets/create", title: "Create Asset" },
  { prefix: "/assets/edit", title: "Edit Asset" },
  { prefix: "/assets/delete", title: "Asset Details" },
  { prefix: "/groups/create", title: "Create Group" },
  { prefix: "/groups/edit", title: "Edit Group" },
  { prefix: "/groups/delete", title: "Group Details" },
  { prefix: "/devices/create", title: "Create Device" },
  { prefix: "/devices/edit", title: "Edit Device" },
  { prefix: "/devices/delete", title: "Device Details" },
  { prefix: "/depots/create", title: "Create Depot" },
  { prefix: "/depots/edit", title: "Edit Depot" },
  { prefix: "/depots/delete", title: "Depot Details" },
  { prefix: "/zones/create", title: "Create POI Zone" },
  { prefix: "/zones/edit", title: "Edit POI Zone" },
  { prefix: "/zones/delete", title: "POI Zone Details" },
  { prefix: "/users/create", title: "Create User" },
  { prefix: "/users/edit", title: "Edit User" },
  { prefix: "/users/delete", title: "User Details" },
  { prefix: "/events/create", title: "Create Event" },
  { prefix: "/events/edit", title: "Edit Event" },
  { prefix: "/events/delete", title: "Event Details" },
  { prefix: "/notifications/create", title: "Create Notification" },
  { prefix: "/notifications/edit", title: "Edit Notification" },
  { prefix: "/notifications/delete", title: "Notification Details" },
];

function getRoutePageTitle(pathname) {
  const path = pathname || "/";

  if (exactPageTitles[path]) {
    return exactPageTitles[path];
  }

  const prefixMatch = prefixPageTitles.find((item) => path.indexOf(item.prefix) === 0);
  if (prefixMatch) {
    return prefixMatch.title;
  }

  const browserTitle = (document.title || "").trim();
  return browserTitle && browserTitle !== "AssetTrak" ? browserTitle : "AssetTrak";
}

class PageVisitTracker extends Component {
  componentDidMount() {
    this.trackVisit(this.props.location);
  }

  componentDidUpdate(prevProps) {
    const previousLocation = prevProps.location;
    const currentLocation = this.props.location;

    if (previousLocation.pathname !== currentLocation.pathname || previousLocation.search !== currentLocation.search) {
      this.trackVisit(currentLocation, `${previousLocation.pathname}${previousLocation.search || ""}`);
    }
  }

  trackVisit = (location, referrerPath) => {
    const token = localStorage.getItem("token");

    if (!token || !location || location.pathname === "/login") {
      return;
    }

    axios
      .post(
        `${apiHost}/api/PageVisit/Track`,
        {
          path: location.pathname,
          queryString: location.search || "",
          pageTitle: getRoutePageTitle(location.pathname),
          referrer: referrerPath || document.referrer || "",
          clientTimestampUtc: new Date().toISOString(),
          sessionVisitId: getSessionVisitId(),
          clientTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          screenWidth: window.screen ? window.screen.width : null,
          screenHeight: window.screen ? window.screen.height : null,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      )
      .catch((error) => {
        if (window && window.console && window.console.warn) {
          window.console.warn("Page visit tracking failed");
        }
      });
  };

  render() {
    return null;
  }
}

export default withRouter(PageVisitTracker);
